import { lazy } from 'react';

// 使用懒加载导入所有页面组件
const Index = lazy(() => import('../pages/index/index'));
const AboutKigen = lazy(() => import('../pages/AboutKigen'));
const CaseStudies = lazy(() => import('../pages/CaseStudies'));
const Technology = lazy(() => import('../pages/Technology'));
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
const Terms = lazy(() => import('../pages/Terms'));



// 路由配置
const routes = [
  {
    path: '/',
    key: 'index',
    element: <Index />,
    exact: true,
  },//Home
  {
    path: '/about-kigen',
    key: 'aboutKigen',
    element: <AboutKigen />,
  },//About Kigen
  {
    path: '/services',
    key: 'services',
    element: <CaseStudies/>,
  },//Services
  {
    path: '/technology',
    key: 'technology',
    element: <Technology />,
  },//Technology
  {
    path: '/privacy-policy',
    key: 'privacy-policy',
    element: <PrivacyPolicy />,
  },//Privacy Policy
  {
    path: '/terms',
    key: 'terms',
    element: <Terms />,
  },//Terms of Service


];

export default routes;
